import { render, staticRenderFns } from "./EvidencePage.vue?vue&type=template&id=78213a60&scoped=true"
import script from "./EvidencePage.vue?vue&type=script&lang=js"
export * from "./EvidencePage.vue?vue&type=script&lang=js"
import style0 from "./EvidencePage.vue?vue&type=style&index=0&id=78213a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78213a60",
  null
  
)

export default component.exports